<app-page titolo="Articoli" [sottotitolo]="sottotitolo()">
  <button azioni type="button" mat-flat-button color="primary" (click)="new()">
    <mat-icon>add</mat-icon>
    Nuovo articolo
  </button>

  <div class="filtri">
    <mat-form-field class="filtri__ricerca">
      <mat-label>Cerca nel titolo</mat-label>
      <input matInput [formControl]="filtroTitolo" autocomplete="off" />
      @if (filtroTitolo.value) {
        <button
          type="button"
          matSuffix
          mat-icon-button
          aria-label="Svuota la ricerca"
          (click)="filtroTitolo.setValue('')"
        >
          <mat-icon>close</mat-icon>
        </button>
      }
    </mat-form-field>

    <button
      type="button"
      class="filtri__apri"
      mat-stroked-button
      [attr.aria-expanded]="filtriAperti()"
      (click)="filtriAperti.set(!filtriAperti())"
    >
      <mat-icon>filter_list</mat-icon>
      Filtri@if (filtriAttivi().length) {&nbsp;({{ filtriAttivi().length }})}
    </button>

    <div class="filtri__scelte" [class.filtri__scelte--aperte]="filtriAperti()">
      <mat-form-field class="filtri__stato">
        <mat-label>Stato</mat-label>
        <mat-select [formControl]="filtroStato">
          <mat-option [value]="null">Tutti</mat-option>
          <mat-option value="pubblicato">Pubblicati</mat-option>
          <mat-option value="programmato">Programmati</mat-option>
          <mat-option value="bozza">Bozze</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field class="filtri__campo">
        <mat-label>Categoria</mat-label>
        <input
          matInput
          [formControl]="filtroCategoria"
          [matAutocomplete]="autoCategoria"
          autocomplete="off"
          placeholder="Tutte"
        />
        <mat-autocomplete #autoCategoria="matAutocomplete" [displayWith]="nomeCategoria">
          @for (categoria of categorieDataSource | async; track categoria.id) {
            <mat-option [value]="categoria">{{ categoria.nome }}</mat-option>
          }
        </mat-autocomplete>
      </mat-form-field>

      <mat-form-field class="filtri__campo">
        <mat-label>Autore</mat-label>
        <input
          matInput
          [formControl]="filtroAutore"
          [matAutocomplete]="autoAutore"
          autocomplete="off"
          placeholder="Tutti"
        />
        <mat-autocomplete #autoAutore="matAutocomplete" [displayWith]="nomeAutore">
          @for (autore of autoriDataSource | async; track autore.id) {
            <mat-option [value]="autore">{{ autore.blogger }}</mat-option>
          }
        </mat-autocomplete>
      </mat-form-field>

      <mat-form-field class="filtri__data">
        <mat-label>Dal</mat-label>
        <input matInput type="date" [formControl]="filtroDa" />
      </mat-form-field>

      <mat-form-field class="filtri__data">
        <mat-label>Al</mat-label>
        <input matInput type="date" [formControl]="filtroA" />
      </mat-form-field>

      <mat-form-field class="filtri__id">
        <mat-label>ID</mat-label>
        <input matInput type="number" inputmode="numeric" [formControl]="filtroId" />
      </mat-form-field>
    </div>

    <!-- Quello che stai filtrando, in chiaro: prima i campi restavano pieni
         e nessuno diceva perche' l'elenco fosse corto. -->
    <div class="filtri__attivi">
      @for (filtro of filtriAttivi(); track filtro.chiave) {
        <span class="filtro-attivo">
          {{ filtro.etichetta }}
          <button
            type="button"
            class="filtro-attivo__via"
            [attr.aria-label]="'Togli il filtro ' + filtro.etichetta"
            (click)="togliFiltro(filtro.chiave)"
          >
            <mat-icon>close</mat-icon>
          </button>
        </span>
      }
      @if (filtriAttivi().length > 1) {
        <button type="button" mat-button (click)="azzeraFiltri()">Azzera tutti</button>
      }
    </div>
  </div>

  <app-data-table
    [columnDefinitions]="columnDefinitions"
    [pageSizeOptions]="[25, 50, 100]"
    [showFirstLastButtons]="true"
    [caricamento]="caricamentoElenco()"
    [errore]="erroreElenco()"
    [rigaCliccabile]="true"
    [etichettaVuoto]="etichettaVuoto()"
    (rigaScelta)="edit($event)"
    (pageChange)="search(true)"
    (pageSizeChange)="search()"
    (sortChange)="search()"
    (onInit)="search()"
  />
</app-page>

<!-- Celle dell'elenco -->

<ng-template #titoloCella let-articolo>
  <div class="titolo-riga">
    <span class="titolo-riga__testo">{{ articolo.titolo }}</span>
    @if (articolo.permalink) {
      <span class="titolo-riga__permalink">/{{ articolo.permalink }}</span>
    }
  </div>
</ng-template>

<ng-template #statoCella let-articolo>
  @if (statoDi(articolo); as stato) {
    <span class="stato stato--{{ stato.codice }}">{{ stato.etichetta }}</span>
  }
</ng-template>

<ng-template #segnaliCella let-articolo>
  <span class="segnali">
    @if (articolo.evidenza === '1') {
      <mat-icon class="evidenza" matTooltip="In primo piano nazionale" aria-label="In primo piano nazionale">
        push_pin
      </mat-icon>
    }
    @if (mittenteEsterno(articolo); as mittente) {
      <span class="etichetta-chip etichetta-chip--avviso" [matTooltip]="'Inviato da ' + mittente">Da esterno</span>
    }
  </span>
</ng-template>

<ng-template #categoriaCella let-articolo>
  @if (articolo.categoria?.nome) {
    <span class="etichetta-chip">{{ articolo.categoria.nome }}</span>
  }
</ng-template>

<ng-template #autoreCella let-articolo>
  @if (articolo.autore?.blogger) {
    <span class="autore">
      <span class="autore__iniziali" aria-hidden="true">{{ inizialiAutore(articolo) }}</span>
      <span class="autore__nome">{{ articolo.autore.blogger }}</span>
    </span>
  }
</ng-template>

<ng-template #dataCella let-articolo>
  <span [matTooltip]="dataCompleta(articolo.data)">{{ quando(articolo.data) }}</span>
</ng-template>

<ng-template #azioniCella let-articolo>
  <button
    type="button"
    mat-icon-button
    [matMenuTriggerFor]="menoRiga"
    aria-label="Azioni sull'articolo"
    (click)="$event.stopPropagation()"
  >
    <mat-icon>more_vert</mat-icon>
  </button>

  <mat-menu #menoRiga="matMenu" xPosition="before">
    <button type="button" mat-menu-item (click)="edit(articolo)">
      <mat-icon>edit</mat-icon>
      <span>Modifica</span>
    </button>
    @if (azioniSito(articolo)) {
      <button type="button" mat-menu-item (click)="apriSulSito(articolo)">
        <mat-icon>open_in_new</mat-icon>
        <span>Visualizza sul sito</span>
      </button>
      <button type="button" mat-menu-item (click)="apriSulSito(articolo, true)">
        <mat-icon>autorenew</mat-icon>
        <span>Aggiorna cache</span>
      </button>
    }
    <button
      type="button"
      mat-menu-item
      [disabled]="articolo.shared == 1 || statoDi(articolo).codice !== 'pubblicato'"
      (click)="pubblicaSuiSocial(articolo)"
    >
      <mat-icon>share</mat-icon>
      <span>{{ articolo.shared == 1 ? 'Gia pubblicato sui social' : 'Pubblica sui social' }}</span>
    </button>
    @if (authService.user?.can('owners')) {
      <button type="button" mat-menu-item (click)="eliminaArticolo(articolo)">
        <mat-icon>delete</mat-icon>
        <span>Elimina</span>
      </button>
    }
  </mat-menu>
</ng-template>
